import GATSBY_COMPILED_MDX from "/opt/build/repo/src/data/posts/2011-12-04-minify-css-with-php.md";
import React from 'react';
import {Link as GatsbyLink} from 'gatsby';
import {format as formatDate} from 'date-fns/format';
import {Stack, Text, Tag, Link, Divider, Box, ListItem, ListIcon, List} from '@chakra-ui/react';
import {IoArrowBackOutline} from 'react-icons/io5';
import {TbCircleDotFilled} from 'react-icons/tb';
import isNil from 'lodash/isNil';
import {Disqus} from 'gatsby-plugin-disqus';
import HtmlElements from '../components/HtmlElements';
import {categoryPath, tagPath} from '../utils/paths';
import ButtonLink from '../components/ButtonLink';
import SEO from '../components/SEO';
import useSiteMetadata from '../hooks/useSiteMetadata';
import {jsx as _jsx} from "react/jsx-runtime";
import {jsxs as _jsxs} from "react/jsx-runtime";
import {Fragment as _Fragment} from "react/jsx-runtime";
const PostTemplate = _ref => {
  var _data$post;
  let {data, children, location, pageContext} = _ref;
  const {title, date, category, tags, credits} = data.post || ({});
  const {prodSiteUrl} = useSiteMetadata();
  return _jsxs(_Fragment, {
    children: [_jsxs(ButtonLink, {
      to: "/posts",
      variant: "outline",
      size: "xs",
      mb: 4,
      children: [_jsx(Box, {
        as: "span",
        pr: 1,
        children: _jsx(IoArrowBackOutline, {})
      }), "All posts"]
    }), _jsxs(Stack, {
      direction: "row",
      alignItems: "center",
      children: [date && _jsx(Text, {
        as: "span",
        textTransform: "uppercase",
        fontSize: "sm",
        fontWeight: "bold",
        color: "gray.700",
        children: formatDate(date, 'MMMM do, yyyy')
      }), category && _jsx(Tag, {
        children: _jsx(Link, {
          as: GatsbyLink,
          to: categoryPath(category, 1),
          children: category
        })
      })]
    }), _jsx(HtmlElements.h1, {
      size: "lg",
      mb: 0,
      children: title
    }), _jsx(Divider, {
      my: 4
    }), _jsx(Box, {
      sx: {
        '& img.left, & img.right, & img.center': {
          maxWidth: ['100%', '50%'],
          my: 4,
          mx: 'auto'
        },
        '& img.left + p, & img.right + p': {
          mt: 0
        },
        '& img.left': {
          float: 'left',
          mx: 4,
          ml: 0
        },
        '& img.right': {
          float: 'right',
          mx: 4,
          mr: 0
        },
        '& img.center': {
          my: 4,
          mx: 'auto'
        },
        '& .chakra-divider': {
          clear: 'both',
          my: 6
        },
        '& .chakra-divider + img, & .chakra-divider + p': {
          mt: 0
        },
        '& .credit-html a[href]': {
          textDecoration: 'underline'
        }
      },
      children: children
    }), _jsx(Divider, {
      mt: 10,
      mb: 2
    }), !isNil(credits) && (credits === null || credits === void 0 ? void 0 : credits.length) > 0 && _jsxs(Box, {
      pt: 4,
      sx: {
        clear: 'both'
      },
      fontSize: "xs",
      color: "gray.500",
      children: [_jsx(HtmlElements.h2, {
        size: "sm",
        mb: 2,
        children: "Credits"
      }), _jsx(List, {
        children: credits.map(credit => isNil(credit) ? null : _jsxs(ListItem, {
          display: "flex",
          alignItems: "center",
          children: [_jsx(ListIcon, {
            as: TbCircleDotFilled
          }), _jsx("span", {
            className: "credit-html",
            dangerouslySetInnerHTML: {
              __html: credit
            }
          })]
        }, credit))
      })]
    }), _jsxs(Box, {
      mt: 4,
      children: [date && _jsxs(Text, {
        as: "span",
        textTransform: "uppercase",
        fontSize: "sm",
        fontWeight: "bold",
        color: "gray.700",
        children: ["Published ", formatDate(date, 'MMMM do, yyyy')]
      }), !isNil(tags) && (tags === null || tags === void 0 ? void 0 : tags.length) > 0 && _jsx(Stack, {
        flexDirection: "row",
        mt: 2,
        spacing: 2,
        display: "flex",
        justifyItems: "left",
        children: tags.map(tag => isNil(tag) ? null : _jsx(Tag, {
          as: Tag,
          mt: 0,
          colorScheme: "blackAlpha",
          children: _jsx(Link, {
            as: GatsbyLink,
            to: tagPath(tag, 1),
            children: tag
          })
        }, tag))
      })]
    }), _jsx(Box, {
      mt: 8,
      mb: 2,
      children: _jsx(Disqus, {
        config: {
          url: `${prodSiteUrl}${location.pathname}`,
          identifier: pageContext.id,
          title: ((_data$post = data.post) === null || _data$post === void 0 ? void 0 : _data$post.title) || ''
        }
      })
    })]
  });
};
export const Head = _ref2 => {
  var _data$post2, _data$post3;
  let {data, location} = _ref2;
  return _jsx(SEO, {
    title: data === null || data === void 0 ? void 0 : (_data$post2 = data.post) === null || _data$post2 === void 0 ? void 0 : _data$post2.title,
    description: data === null || data === void 0 ? void 0 : (_data$post3 = data.post) === null || _data$post3 === void 0 ? void 0 : _data$post3.excerpt,
    pathname: location.pathname
  });
};
const query = "2988110516";
PostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
